























import { Icon } from '@alpha/ink'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Icon
  }
})
export default class ToucanToggle extends Vue {
  @Prop() insight!: any
  @Prop() filters!: any
  @Prop() filterIdx!: any
  @Prop() realDataType!: any

  hovering: Boolean = false
  hoveredGroup: Boolean = false

  hoverGroup (sliceName:any) {
    var that = this
    setTimeout(function () {
      that.hovering = true
      that.hoveredGroup = sliceName
    }, 50)
  }

  resetHover () {
    this.hovering = this.hoveredGroup = false
  }

  selectFilter (filter:any, idx:any) {
    this.$emit('selectFilter', {
      filter: filter,
      idx: idx
    })
  }
}
